module.exports = __webpack_public_path__ + "static/img/3product50x59.f531875.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/3product50x59.jpg
// module id = K7ib
// module chunks = 1